import styled from 'styled-components';
import { SmallSectionHeader } from 'components/Typography';

export const StyledSmallSectionHeader = styled(SmallSectionHeader)`
  font-size: 20px !important;
`;
